<template>
  <div class="student-detail-card-duo" style="background: white">
    <v-row>
      <v-col cols="12" v-if="activeClass === 0">
        <v-tabs
          v-model="activeTab"
          vertical
          hide-slider
          class="custom-duo-tab"
        >
          <v-tab>
            <div class="d-flex align-center justify-start w-100">
              <img v-if="activeTab === DUO_TOP_CONTENT_ACTIVE_TAB.HOMEWORK" src="../../duo_care/assets/duo-tab-icon-active.svg" class="mr-2" alt="">
              <img v-else src="../../duo_care/assets/duo-tab-icon.svg" class="mr-2" alt="">
              <span style="font-size: 14px; text-transform: none;">
                Bài tập &
                <br>
                chuyên cần
              </span>
            </div>
          </v-tab>
          <v-tab>
            <div class="d-flex align-center justify-start w-100">
              <img v-if="activeTab === DUO_TOP_CONTENT_ACTIVE_TAB.TEST" src="../../duo_care/assets/duo-tab-icon-active.svg" class="mr-2" alt="">
              <img v-else src="../../duo_care/assets/duo-tab-icon.svg" class="mr-2" alt="">
              Kiểm tra
            </div>
          </v-tab>
          <v-tab-item>
            <DuoViewDetailBySubject
              :dataTable="studyResult.bySubjectGrade"
              :filterForm="{
                subjectId: activeProgramSubjectId,
                lmsCoreUserID: studentBlendedTutorDetail.lms_core_user_id,
              }"
              :filter="filter"
            ></DuoViewDetailBySubject>
          </v-tab-item>
          <v-tab-item>
            <DuoTestTab
              :items="dataTestDuo"
              :subject-id="activeProgramSubjectId"
            >
            </DuoTestTab>
          </v-tab-item>
        </v-tabs>
      </v-col>
      <v-col
        :cols="12"
        v-if="activeClass === 1"
      >
        <div class="d-flex justify-center align-center">
          <SelfStudyViewDetailBySubject
            :subject-id="activeProgramSubjectId"
            :dataTable="selfStudyResult.byGrade"
          ></SelfStudyViewDetailBySubject>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import SelfStudyViewDetailBySubject
from '@/modules/duo_care/components/detail/SelfStudyViewDetailBySubject.vue';
import DuoTestTab from '@/modules/duo_care/components/DuoTestTab.vue';
import DuoViewDetailBySubject from '@/modules/duo_care/components/detail/DuoViewDetailBySubject.vue';
// import SelfStudyViewDetailBySubject from '@/modules/duo_care/components/detail/SelfStudyViewDetailBySubject.vue';
// import DuoViewDetailBySkill from '@/modules/duo_care/components/detail/DuoViewDetailBySkill.vue';
import moment from 'moment/moment';
import StudentCareServices from '@/services/StudentCareServices';
import { mapActions, mapState } from 'vuex';
import { tabViewDuoCare, DUO_TOP_CONTENT_ACTIVE_TAB } from '../../duo_care/constant';

export default {
  name: 'DuoStudentDetail',
  components: {
    DuoViewDetailBySubject,
    DuoTestTab,
    SelfStudyViewDetailBySubject,
  },
  data() {
    return {
      activeTab: 0,
      DUO_TOP_CONTENT_ACTIVE_TAB,
      loading: false,
      currentTab: 0,
      tabView: tabViewDuoCare,
      isViewAll: true,
      filter: {
        dateMonth: '',
        typeViewFilter: 'detail',
      },
      // filterForm: {
      //   subjectId: '',
      //   lmsCoreUserID: '',
      // },
      dataTableBySubjectClone: [],
      dataTableBySubject: [],
      dataTableBySkill: [],
      dataTestDuo: [],
    };
  },
  computed: {
    ...mapState('student_detail_bt', ['activeFilterSubject', 'studentBlendedTutorDetail', 'filterForm', 'activeProgramSubjectId']),
    ...mapState('duo_care', ['studyResult', 'activeClass', 'selfStudyResult']),
  },
  created() {
    this.getDuoStudyResult();
    this.getDuoTestResult();
  },
  watch: {
    filterForm: {
      deep: true,
      async handler(val) {
        const params = {
          userId: this.studentBlendedTutorDetail.lms_core_user_id,
          startTime: moment(val.dateTime[0]).format('YYYY-MM-DD'),
          endTime: moment(val.dateTime[1]).format('YYYY-MM-DD'),
          subjectId: this.activeProgramSubjectId,
        };
        if (this.activeClass) {
          this.getSelfStudyResult(params);
        } else {
          this.getStudyResult(params);
          this.getDuoTestResult();
        }
      },
    },
    async activeFilterSubject() {
      const params = {
        userId: this.studentBlendedTutorDetail.lms_core_user_id,
        startTime: moment(this.filterForm.dateTime[0]).format('YYYY-MM-DD'),
        endTime: moment(this.filterForm.dateTime[1]).format('YYYY-MM-DD'),
        subjectId: this.activeProgramSubjectId,
      };
      if (this.activeClass) {
        this.getSelfStudyResult(params);
      } else {
        this.getStudyResult(params);
        this.getDuoTestResult();
      }
    },
  },
  methods: {
    ...mapActions('duo_care', ['getStudyResult', 'getSelfStudyResult']),
    async getDuoTestResult() {
      const loading = this.$loading.show();
      const result = await StudentCareServices.getDuoTestResult({
        subjectId: this.activeProgramSubjectId,
        userId: this.studentBlendedTutorDetail.lms_core_user_id,
        startTime: moment(this.filterForm.dateTime[0]).format('YYYY-MM-DD'),
        endTime: moment(this.filterForm.dateTime[1]).format('YYYY-MM-DD'),
      });
      if (result.message === 'Success') {
        this.dataTestDuo = result.data;
      }
      loading.hide();
    },
    async getDuoStudyResult() {
      const params = {
        userId: this.studentBlendedTutorDetail.lms_core_user_id,
        startTime: moment(this.filterForm.dateTime[0]).format('YYYY-MM-DD'),
        endTime: moment(this.filterForm.dateTime[1]).format('YYYY-MM-DD'),
        subjectId: this.activeProgramSubjectId,
      };
      this.getStudyResult(params);
    },
    async getDataViewTable() {
      if (this.studentBlendedTutorDetail.lms_core_user_id) {
        this.loading = true;
        const range = moment(this.filterForm.dateTime[0]).diff(moment(this.filterForm.dateTime[1]), 'days');
        const params = {
          type: this.currentTab === 0 ? 'duo' : 'selfStudy',
          userId: this.studentBlendedTutorDetail.lms_core_user_id,
          // userId: 1009240,
          currentTime: moment(new Date()).format('YYYY-MM-DD 00:00:00'),
          startTime: moment(this.filterForm.dateTime[0]).format('YYYY-MM-DD 00:00:00'),
          endTime: moment(this.filterForm.dateTime[1]).format('YYYY-MM-DD 23:59:59'),
          prevStartTime: moment(this.filterForm.dateTime[0]).subtract(1 + Math.abs(range), 'd').format('YYYY-MM-DD 00:00:00'),
          prevEndTime: moment(this.filterForm.dateTime[0]).subtract(1, 'd').format('YYYY-MM-DD 23:59:59'),
        };
        const res = await StudentCareServices.homeWorkReport(params);
        this.loading = false;
        if (res?.success) {
          this.dataTableBySubject = res?.data;
        }
        this.getDataViewTableBySubject();
      }
    },
    getDataViewTableBySubject() {
      this.dataTableBySubjectClone = _.cloneDeep(this.dataTableBySubject);
      this.dataTableBySubjectClone = this.activeFilterSubject !== 'Tất cả' ? this.dataTableBySubjectClone.filter((e) => e.subjectName === this.activeFilterSubject) : this.dataTableBySubjectClone;
      if (this.currentTab === 1 && this.filterForm.subjectId) { // Tự học
        this.dataTableBySkill = (this.dataTableBySubjectClone && this.dataTableBySubjectClone[0]?.components.length ? this.dataTableBySubjectClone[0].components : this.dataTableBySubjectClone[0]?.skills) || [];
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.custom-duo-tab {
  .v-tab {
    background: #F8F7F7;
    border-radius: 8px;
    margin-bottom: 12px;
    color: #BBBBBB;
    text-transform: none !important;
    font-weight: normal;
  }
  .v-tab--active {
    background: #E3F0FF !important;
    color: black !important;
  }
}
.student-detail-card-duo {
  width: 98%;
  border-radius: 12px;
  background: white;
  padding: 16px;
}
  @media screen and (max-width: 1440px) {
.student-detail-card-duo {
  font-size: 12px !important;
}
  }
</style>
<style>
.active-tab {
  background: #e8e8ef;
}
.custom-tab-duo .v-tabs-slider-wrapper{
  display: none !important;
}
.custom-tab-duo .v-tab {
  border-radius: 8px;
  background-color: #F5F5F5;
  margin-bottom: 14px;
  filter: grayscale(1)
}
.custom-tab-duo .active-tab {
  background-color: #DBECFC;
  color: #2F80ED;
  filter: none;
}
.custom-tab-duo .v-slide-group__content.v-tabs-bar__content {
  background: white;
}
</style>
